import { Rutas } from '@/constants/rutas';
import AIAssistantIcon from '../../icons/AIAssistantIcon';

export const NavigationUsuarioItems = [
    {
        title: 'Plantillas',
        shortTitle: 'Plantillas',
        path: Rutas.MIS_PLANTILLAS,
    },
    {
        title: 'Analiza tu plantilla',
        path: Rutas.ANALIZA_TU_PLANTILLA,
        id: 'plantillas',
        shortTitle: 'Analiza tu plantilla',
        icon: <AIAssistantIcon width={50} height={50} />,
        hideShortTitle: true,
    },
    {
        title: 'Tierlists',
        shortTitle: 'Tierlists',
        path: Rutas.TIER_LIST,
    },
    {
        title: 'Recomendaciones',
        shortTitle: 'Recomendaciones',
        path: Rutas.RECOMENDACIONES,
    },
];
